<template>
  <ul v-if="data.conflicts || solvedConflicts || data.errors" class="status__list">
    <li class="status__list__item">
      <Label
        :value="(Number(data.success || 0) + Number(data.updates || 0))"
        :colored="Boolean(data.success) || Boolean(data.updates)"
        success
        icon
      />

      <span class="status__list__item__text">
        {{ $t(`${namespace}.validRegistrationRequests`) }}&nbsp;
        <strong v-if="solvedConflicts" class="success--text">({{ solvedConflicts | formatNumber }} {{ $t(`${namespace}.employeeConflictsResolved`) }})</strong>
        <strong v-if="data.updates" class="success--text">({{ data.updates | formatNumber }} {{ $t(`${namespace}.employeeUpdated`) }})</strong>
      </span>
    </li>

    <li v-if="data.conflicts || solvedConflicts" class="status__list__item">
      <Label
        :value="data.conflicts"
        :colored="Boolean(data.conflicts)"
        warning
        icon
      />

      <span v-html="$t(`${namespace}.conflictEmployees`)" class="status__list__item__text" />

      <a
        v-if="solvedConflicts"
        :title="$t(`${namespace}.undoSolutions`)"
        class="status__list__item__link"
        @click.prevent="handleUndoSolutions"
      >
        {{ $t(`${namespace}.undoSolutions`) }}
      </a>

      <a
        v-else
        :title="$t(`${namespace}.solvedConflicts`)"
        class="status__list__item__link"
        @click.prevent="handleSolvedConflicts"
      >
        {{ $t(`${namespace}.solvedConflicts`) }}
      </a>
    </li>

    <li v-if="data.errors" class="status__list__item">
      <Label
        :value="data.errors"
        :colored="Boolean(data.errors)"
        error
        icon
      />

      <span v-html="$t(`${namespace}.invalidRequests`)" class="status__list__item__text" />

      <a
        :title="$t(`${namespace}.reviewErrors`)"
        class="status__list__item__link"
        @click.prevent="handleReviewErrors"
      >
        {{ $t(`${namespace}.reviewErrors`) }}
      </a>
    </li>
  </ul>
</template>

<script>
import Label from 'components/bulkImport/Label'

export default {
  name: 'StatusList',
  props: {
    data: {
      type: Object,
      required: true
    },
    solvedConflicts: {
      type: Number,
      default: 0
    }
  },
  components: {
    Label
  },
  data () {
    return {
      namespace: 'Views.BulkImportPage.status.list'
    }
  },
  methods: {
    handleSolvedConflicts () {
      this.$emit('solvedConflicts')
    },

    handleUndoSolutions () {
      this.$emit('undoSolutions')
    },

    handleReviewErrors () {
      this.$emit('reviewErrors')
    }
  }
}
</script>

<style lang="scss" scoped>
.status__list {
  list-style-type: none;
  padding: 0;
}

.status__list__item {
  align-items: center;
  border-bottom: 1px solid var(--gray-4);
  display: flex;
  flex-direction: column;
  padding: 16px 24px;

  @media (min-width: 768px) {
    flex-direction: row;
  }
}

.status__list__item__text {
  flex: 1;
  margin-left: 8px;
  margin-top: 8px;

  @media (min-width: 768px) {
    margin-top: 0;
  }
}

.status__list__item__link {
  color: var(--accent);
  text-decoration: none;
}
</style>
